import {
  DateField,
  DateRangePicker,
  Label,
  RangeCalendar,
} from "@heroui/react";

export function DateRangeFilter({
  label,
  onChange,
  testId = "date-range-filter",
}: {
  label: string;
  onChange?: (range: { start: string; end: string } | null) => void;
  testId?: string;
}) {
  return (
    <div data-testid={testId}>
    <DateRangePicker
      className="scd-date-range"
      startName="start"
      endName="end"
      onChange={(
        rangeVal: {
          start: { toString(): string };
          end: { toString(): string };
        } | null,
      ) => {
        if (onChange) {
          if (rangeVal?.start && rangeVal?.end) {
            onChange({
              start: rangeVal.start.toString(),
              end: rangeVal.end.toString(),
            });
          } else {
            onChange(null);
          }
        }
      }}
    >
      <Label className="sr-only">{label}</Label>
      <DateField.Group fullWidth>
        <DateField.Input slot="start">
          {(segment) => <DateField.Segment segment={segment} />}
        </DateField.Input>
        <DateRangePicker.RangeSeparator />
        <DateField.Input slot="end">
          {(segment) => <DateField.Segment segment={segment} />}
        </DateField.Input>
        <DateField.Suffix>
          <DateRangePicker.Trigger>
            <DateRangePicker.TriggerIndicator />
          </DateRangePicker.Trigger>
        </DateField.Suffix>
      </DateField.Group>
      <DateRangePicker.Popover>
        <RangeCalendar aria-label={label}>
          <RangeCalendar.Header>
            <RangeCalendar.YearPickerTrigger>
              <RangeCalendar.YearPickerTriggerHeading />
              <RangeCalendar.YearPickerTriggerIndicator />
            </RangeCalendar.YearPickerTrigger>
            <RangeCalendar.NavButton slot="previous" />
            <RangeCalendar.NavButton slot="next" />
          </RangeCalendar.Header>
          <RangeCalendar.Grid>
            <RangeCalendar.GridHeader>
              {(day) => (
                <RangeCalendar.HeaderCell>{day}</RangeCalendar.HeaderCell>
              )}
            </RangeCalendar.GridHeader>
            <RangeCalendar.GridBody>
              {(date) => <RangeCalendar.Cell date={date} />}
            </RangeCalendar.GridBody>
          </RangeCalendar.Grid>
          <RangeCalendar.YearPickerGrid>
            <RangeCalendar.YearPickerGridBody>
              {({ year }) => <RangeCalendar.YearPickerCell year={year} />}
            </RangeCalendar.YearPickerGridBody>
          </RangeCalendar.YearPickerGrid>
        </RangeCalendar>
      </DateRangePicker.Popover>
    </DateRangePicker>
    </div>
  );
}
